import { MAX_EFFICE_CONTENT_CHARS } from "constants/constants";
import React from "react";
import { useDispatch } from "react-redux";
import { setInputBoxActive } from "slices/generalSlice";

const EdittingText = ({ elem, content, setContent, loading }) => {
  const dispatch = useDispatch();

  return (
    <textarea
      className="Txt-input-entry input-edit"
      value={content}
      maxLength={MAX_EFFICE_CONTENT_CHARS}
      placeholder="Text"
      disabled={loading}
      ref={elem}
      onChange={(e) => {
        if (e.target.value.length < MAX_EFFICE_CONTENT_CHARS)
          setContent(e.target.value);
      }}
      onFocus={() => dispatch(setInputBoxActive(true))}
      onBlur={() => dispatch(setInputBoxActive(false))}
    />
  );
};

export default EdittingText;
